module.exports = __webpack_public_path__ + "static/media/BillmannSq.0b7184f6.jpg";